<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0" primary-title>
          Setar Colaborador
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            v-model="colaborador"
            :items="colaboradores"
            item-text="Descricao"
            return-object
            menu-props="auto"
            label="Colaborador"
            hide-details
            prepend-icon="group_add"
            class="mb-3"
            auto-select-first
            no-data-text="Registro não encontrado."
          ></v-autocomplete>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  props: ["value", "atividadeColaborador", "loading"],
  data() {
    return {
      colaborador: null
    };
  },
  methods: {
    ...mapMutations(["showNotification"]),
    ...mapActions(['fetchColaboradores']),
    adiciona() {
      if (this.colaborador) {
        if (this.atividadeColaborador !== null) {
          this.atividadeColaborador.IdColaborador = this.colaborador.IdColaborador;
          this.atividadeColaborador.Colaborador = this.colaborador.Descricao;
          this.$emit("setaColaborador", this.atividadeColaborador);
          this.colaborador = null;
        } else {
          this.$emit("setaColaboradorSelected", this.colaborador);
          this.colaborador = null;
        }
      } else {
        this.showNotification({ text: "Informe o colaborador", status: 'error' });
      }
    }
  },
  computed: {
    ...mapGetters(["colaboradores"])
  },
  async created() {
    if (!this.colaboradores.length) {
      await this.fetchColaboradores();
    }
  }
};
</script>

<style>
</style>
